import axios from 'axios';
const API = 'https://omni-api.seasungames.cn/api/omni/v1/openapi';

/**
 *  获取omni数据
 * @param {*} postion 分发位置
 * @returns
 */
export function getOmniData(postion, dataSources) {
  return axios
    .get(`${API}/get_position_data`, {
      params: {
        format: '',
        param: JSON.stringify({
          lang: 'zh-Hans',
          positions: [
            {
              dataSources: dataSources,
              position: postion
            }
          ]
        })
      }
    })
    .then(res => {
      if (res.data.status !== 0 /*非成功返回*/) {
        return Promise.reject(res.data);
      }

      return res.data.data?.[postion];
    });
}

export function getOmniDetail(contentId) {
  return axios
    .get(`${API}/get_detail`, {
      params: {
        format: '',
        param: JSON.stringify({
          lang: 'zh-Hans',
          contentId: contentId
        })
      }
    })
    .then(res => {
      if (res.data.status !== 0 /*非成功返回*/) {
        return Promise.reject(res.data);
      }
      return res.data.data?.[contentId];
    });
}

export const getOmniSearch = ({ keywords, categoryId = '', page = 1, pageSize = 12 }) => {
  let url = `/search/datasource/index_ds_d71d6026?_omni_withDict&_omni_aggField=categoryId&_omni_text=${keywords}&page=${page}&pageSize=${pageSize}`;
  if (categoryId) {
    url += `&categoryId=${categoryId}`;
  }
  return axios.get(`${API}${url}`).then(res => {
    if (res.data.status !== 0 /*非成功返回*/) {
      return Promise.reject(res.data);
    }
    return res.data.data;
  });
};

export const findKeyByTitle = (title, data) => {
  const entry = Object.entries(data).find(([key, value]) => value.title === title);
  return entry ? entry[0] : null;
};

export const Ids = {
  kv: {
    channel: 'channel_cat_d7ecc43c',
    dataSources: {
      kv: 'ds_cat_ecc43c3b' // 首屏KV图片
    }
  }
};
